module.exports = __webpack_public_path__ + "img/catalogues_small.4c30e4dc.svg";